<!-- ✅ SIDEBAR + MAIN CONTENT LAYOUT FIXED VERSION -->

<!-- Custom style to keep active link orange -->
<style>
  .sidebar ul.list li.active > a span {
    color: #E67E22 !important; 
  }
  .sidebar ul.list li.active > a {
    border-bottom: 1px solid #f3d9c3;
  }
</style>

<!-- ✅ MAIN CONTAINER -->
<div class="main-container"
     style="display: flex; height: 100vh; width: 100%; background-color: #f4f7f6; position: relative; overflow: hidden;">

  <!-- ✅ SIDEBAR -->
  <div 
    id="sidebar-fixed"
    class="sidebar-wrapper"
    style="
      width: 250px;
      flex-shrink: 0;
      background-color: #ffffff;
      border-right: 2px solid #2196f3;
      z-index: 3000;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      overflow-y: auto;
      height: 100vh;
      box-shadow: 3px 0 6px rgba(0,0,0,0.1);
      display: flex;
      flex-direction: column;
      visibility: visible;
      opacity: 1;
      transform: none;
    "
  >
    <app-sidebar></app-sidebar>
  </div>

  <!-- ✅ MAIN CONTENT -->
  <div 
    class="main-content"
    style="
      margin-left: 250px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      position: relative;
      height: 100vh;
      background-color: #f4f7f6;
      transition: margin-left 0.3s ease-in-out;
      z-index: 100;
    "
  >
    <!-- Header -->
    <div 
      class="header-wrapper"
      style="
        position: sticky;
        top: 0;
        z-index: 2000;
        background-color: #F5F6F5;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        height: 70px;
      "
    >
      <app-header></app-header>
    </div>

    <!-- Sub Header -->
    <div 
      class="sub-header-wrapper"
      style="
        background-color: #F5F6F5;
        padding: 12px 24px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        z-index: 1500;
        margin-top: 30px;
      "
    >
      <app-headers></app-headers>
    </div>

    <!-- Router Outlet -->
    <div 
      class="page-wrapper"
      [dir]="direction"
      style="padding: 24px; flex-grow: 1;"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- ✅ RESPONSIVE FIXES -->
<style>
  /* Ensure sidebar always visible below 1170px */
  @media (max-width: 1170px) {
    .sidebar-wrapper {
      position: fixed !important;
      width: 250px !important;
      left: 0 !important;
      top: 0 !important;
      bottom: 0 !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      display: flex !important;
      background-color: #fff !important;
      z-index: 4000 !important;
    }

    .main-content {
      margin-left: 250px !important;
    }

    /* Prevent sidebar from being hidden by overflow */
    .main-container {
      overflow: visible !important;
    }
  }

  /* Sidebar scrollable with thin scrollbar */
  .sidebar-wrapper {
    overflow-y: auto;
    scrollbar-width: thin;
  }

  /* Ensure the sidebar’s content never disappears */
  #leftsidebar, aside.sidebar {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    transform: none !important;
  }
</style>
